import { render, staticRenderFns } from "./yjbj.vue?vue&type=template&id=1d782e98"
import script from "./yjbj.vue?vue&type=script&lang=js"
export * from "./yjbj.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports